import { QueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { ERROR_MESSAGES } from './constants';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 30, // 30 minutes
      retry: (failureCount, error) => {
        // Don't retry on 404s or auth errors
        if (
          error instanceof Error &&
          (error.message.includes('404') || error.message.includes('401'))
        ) {
          return false;
        }
        return failureCount < 3;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,
      onError: error => {
        console.error('Query error:', error);
        toast.error(error instanceof Error ? error.message : ERROR_MESSAGES.GENERIC);
      },
    },
    mutations: {
      retry: 2,
      onError: (error, variables, context) => {
        console.error('Mutation error:', { error, variables, context });
        toast.error(error instanceof Error ? error.message : ERROR_MESSAGES.GENERIC);
      },
      onSuccess: () => {
        // Optionally show success toast
        // toast.success('Operation completed successfully');
      },
    },
  },
});

// Pre-configured query hooks
export const queryKeys = {
  user: ['user'],
  invoices: ['invoices'],
  payslips: ['payslips'],
  expenses: ['expenses'],
  documents: ['documents'],
  aiFeatures: ['ai-features'],
  teams: ['teams'],
  workflows: ['workflows'],
} as const;
